"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _has = _interopRequireDefault(require("lodash/has"));
var reduxThunk = _interopRequireWildcard(require("redux-thunk"));
var _intlMiddleware = _interopRequireDefault(require("./intlMiddleware"));
var _analyticsMiddleware = _interopRequireDefault(require("./analyticsMiddleware"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var middlewares = {
  intl: _intlMiddleware.default,
  // A compatibility layer for redux-thunk v2 vs v3. In v3, the default export is removed.
  reduxThunk: reduxThunk.thunk || reduxThunk.default,
  analytics: _analyticsMiddleware.default
};

// Provide a function so consumers can override a middleware if they want to
var customize = function customize(mods) {
  return Object.keys(middlewares).map(function (key) {
    if (mods && (0, _has.default)(mods, key)) {
      return mods[key](middlewares[key]);
    }
    return middlewares[key];
  }).filter(function (el) {
    return el;
  });
};
var toArray = function toArray() {
  return customize();
};
var defaultArray = toArray();
defaultArray.customize = customize;

// Export array of middlewares
var _default = exports.default = defaultArray;